import script from "./LandingHeroFacts.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingHeroFacts.vue?vue&type=script&setup=true&lang=js"

import "./LandingHeroFacts.vue?vue&type=style&index=0&id=79e3910d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e3910d"]])

export default __exports__